import { render } from "./mega-menu-image.vue?vue&type=template&id=097f13e7"
import script from "./mega-menu-image.vue?vue&type=script&lang=js"
export * from "./mega-menu-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__